export default __webpack_public_path__ + "assets/landing-page-3.jpg";